import { LockDataResponse } from './LockDataResponse';
import { PlantCCDC } from '../../../../masterdata/models/PlantCCDC';

export interface LockState {
    lockData: LockDataResponse | null;
    loadingLockData: boolean;
    lockCCDCList: PlantCCDC[];
    loadingLockCCDCList: boolean;
    showLockControlPopup: boolean;
    userLockedOut: boolean;
}

export const initialLockState: LockState = {
    lockData: null,
    loadingLockData: false,
    lockCCDCList: [],
    loadingLockCCDCList: false,
    showLockControlPopup: false,
    userLockedOut: false
};
